import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: '',
};

export const counterSlice = createSlice({
  name: "Auth",
  initialState,
  reducers: {
    getAuth: (state, action) => {

      state.value = action.payload;
    },
    setAuth: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { getAuth, setAuth } = counterSlice.actions;

export default counterSlice.reducer;
